const types = {
  SET_EXPECTED_RESULTS: "SET_EXPECTED_RESULTS",
  SET_SELECTED_EXPECTED_RESULT: "SET_SELECTED_EXPECTED_RESULT",
  SET_INDICATORS: "SET_INDICATORS",
  SET_UNITY_INDICATORS: "SET_UNITY_INDICATORS",
  SET_SELECTED_INDICATOR: "SET_SELECTED_INDICATOR",
  SET_UNIT_ACTIVITIES: "SET_UNIT_ACTIVITIES",
  SET_SELECTED_ACTIVITY: "SET_SELECTED_ACTIVITY",
  SET_MY_ACTIVITIES: "SET_MY_ACTIVITIES",
  SET_SUBORDINATES: "SET_SUBORDINATES",
  SET_SELECTED_USER_ENTITY: "SET_SELECTED_USER_ENTITY",
  SET_USER_ENTITIES: "SET_USER_ENTITIES",
  SET_SELECTED_FISCAL_YEAR: "SET_SELECTED_FISCAL_YEAR",
  SET_FISCAL_YEARS: "SET_FISCAL_YEARS",
  ADD_NEW_EXPECTED_RESULT: "ADD_NEW_EXPECTED_RESULT",
  UPDATE_EXPECTED_RESULT: "UPDATE_EXPECTED_RESULT",
  DELETE_EXPECTED_RESULT: "DELETE_EXPECTED_RESULT",
  ADD_NEW_INDICATOR: "ADD_NEW_INDICATOR",
  UPDATE_INDICATOR: "UPDATE_INDICATOR",
  SET_INDICATOR_ACTIVITIES: "SET_INDICATOR_ACTIVITIES",
  DELETE_INDICATOR: "DELETE_INDICATOR",
  SET_UNITS: "SET_UNITS",
  UPDATE_ACTIVITY: "UPDATE_ACTIVITY",
  ADD_NEW_ACTIVITY: "ADD_NEW_ACTIVITY",
  DELETE_ACTIVITY: "DELETE_ACTIVITY",
  SET_INSTITUTIONS_EVALUATIONS: "SET_INSTITUTIONS_EVALUATIONS",
  SET_UNITS_EVALUATIONS: "SET_UNITS_EVALUATIONS",
  SET_EMPLOYEES_EVALUATIONS: "SET_EMPLOYEES_EVALUATIONS",
  ADD_ACTIVITY_ASSIGNMENT: "ADD_ACTIVITY_ASSIGNMENT",
  REMOVE_ACTIVITY_ASSIGNMENT: "REMOVE_ACTIVITY_ASSIGNMENT",
  ADD_ACTIVITY_SUBMISSION: "ADD_ACTIVITY_SUBMISSION",

  REMOVE_ACTIVITY_SUBMISSION: "REMOVE_ACTIVITY_SUBMISSION",
  ADD_ACTIVITY_EVALUATION: "ADD_ACTIVITY_EVALUATION",
  REMOVE_ACTIVITY_EVALUATION: "REMOVE_ACTIVITY_EVALUATION",

  SET_SUBORDINATES_EVALUATIONS: "SET_SUBORDINATES_EVALUATIONS",
  SET_SUBORDINATE_ACTIVITIES: "SET_SUBORDINATE_ACTIVITIES",
  SET_COMPETENCIES_DESCRIPTORS: "SET_COMPETENCIES_DESCRIPTORS",
  UPDATE_COMPETENCY_DESCRIPTOR: "UPDATE_COMPETENCY_DESCRIPTOR",
  UPDATE_SUBORDINATE_EVALUATIONS: "UPDATE_SUBORDINATE_EVALUATIONS",
  SET_RRA_EVALUATION: "SET_RRA_EVALUATION",
  SET_RRA_OVERALL_EVALUATIONS: "SET_RRA_OVERALL_EVALUATIONS",
  UPDATE_RRA_OVERALL_EVALUATION: "UPDATE_RRA_OVERALL_EVALUATION",
  SET_MY_SCORES: "SET_MY_SCORES",
  SET_SUBORDINATE_SCORES: "SET_SUBORDINATE_SCORES",
};

export default types;
